import { NavLink } from "react-router-dom";
import { Receipt, AlertCircle, LayoutDashboard, FileText, ClipboardCheck } from "lucide-react";

/** Sub-tabs shown at the top of every Billing page. */
const TABS = [
  { to: "/app/billing",             label: "Dashboard",   icon: LayoutDashboard, end: true },
  { to: "/app/billing/invoices",    label: "Invoices",    icon: Receipt },
  { to: "/app/billing/quotations",  label: "Quotations",  icon: ClipboardCheck },
  { to: "/app/billing/outstanding", label: "Outstanding", icon: AlertCircle },
  { to: "/app/billing/reports",     label: "Reports",     icon: FileText },
];

export default function BillingTabs() {
  return (
    <div className="flex items-center gap-1 border-b border-[#E8EAE9] mb-4"
         data-testid="billing-tabs">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          data-testid={`billing-tab-${t.label.toLowerCase()}`}
          className={({ isActive }) =>
            `inline-flex items-center gap-1.5 px-4 py-2.5 text-sm border-b-2 transition ${
              isActive
                ? "border-pine text-ink font-medium"
                : "border-transparent text-ink-soft hover:text-ink"
            }`
          }
        >
          <t.icon className="w-4 h-4" />
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
